import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <main className="not-found-page" aria-labelledby="not-found-title">
      <h1 id="not-found-title">Page not found</h1>
      <p>This URL does not exist on integra3646.com.</p>
      <Link to="/" className="not-found-link">
        Return to homepage
      </Link>
    </main>
  );
};

export default NotFound;
